import { createContext, useContext, useState } from 'react';

/**
 * Array of ItemIdentifiers representing the currently selected content.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentSelectionStateContext = /*#__PURE__*/createContext(undefined);
export const ContentSelectionStateDispatch = /*#__PURE__*/createContext(undefined);

/**
 * Returns the current selection for the nearest provider, or undefined if not under a ContentSelectionProvider.
 */
export const useContentSelectionState = () => {
  return useContext(ContentSelectionStateContext);
};

/**
 * Dispatch a new selection to all components consuming this provider. Will return undefined if not
 * under a ContentSelectionProvider.
 */
export const useContentSelectionDispatch = () => {
  return useContext(ContentSelectionStateDispatch);
};
/**
 * Provides a shared selection context for components that consume this provider. Components can
 * consume and dispatch changes to the current selection using the hooks.
 * @param initialValue
 * @param children
 * @constructor
 */
export const ContentSelectionProvider = ({
  initialValue,
  children
}) => {
  const [state, setState] = useState(initialValue);
  return /*#__PURE__*/_jsx(ContentSelectionStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/_jsx(ContentSelectionStateDispatch.Provider, {
      value: setState,
      children: children
    })
  });
};
//# sourceMappingURL=ContentSelectionProvider.js.map